import React, { ChangeEvent, ComponentProps, FocusEvent, useState } from "react";
import AppIcon from "src/commun/composants/AppIcon";
import { useAppText } from "src/commun/composants/AppText";
import AppInput from "src/commun/composants/formulaire/AppInput/AppInput";
import styles from "./AppRecherche.scss";

export type AppRechercheProps = ComponentProps<"input">;

const AppRecherche = ({ name, onChange, value, defaultValue, onFocus }: AppRechercheProps) => {
  const { tString } = useAppText();

  const [currentValue, setcurrentValue] = useState(value as string);

  const onChangeLocal = (event: ChangeEvent<HTMLInputElement>) => {
    setcurrentValue(event.target.value);
    if (onChange) {
      onChange(event);
    }
  };

  const onFocusHandler = (event: FocusEvent<HTMLInputElement, Element>) => {
    if (onFocus) {
      onFocus(event);
    }
  };

  const nameLocal = name ? name : "recherche";

  return (
    <div className={styles.rechercheContainer}>
      <AppIcon name="rechercher" size="24px" className="icon-style-dark" />
      <AppInput
        name={nameLocal}
        autoComplete="off"
        placeholder={defaultValue ? tString(defaultValue as string) : tString("global.rechercher")}
        onChange={onChangeLocal}
        value={currentValue}
        className={styles.rechercheInput}
        onFocus={onFocusHandler}
      />
    </div>
  );
};

export default AppRecherche;
